import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBTextField, DBCheckBox, DBTextArea, DBDropDownObjective } from '_components';
import styles from './Common.module.css';
import {
    PatientCareCenterNoteAssessmentBarriers,
} from 'PatientCareCenter/Note/WorkProgram/Assessment'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { PatientCareCenterNoteSubjectivePDCSelector } from './PDCSelector';

class PatientCareCenterNoteWpAssessment extends React.Component {

    handleChange(res, field) {
        if (!res) {
            this.props.clearField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, field);
        }

    }

    handleDiagChange(event) {
        if (event.target.value === '-1') {
            this.props.clearField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, 'ASWPCANDIDATEISISNOT');
        }
        else if (event.target.value !== this.props.diagVal) {
            if (event.target.value === '1') {
                this.props.updateBitField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, 'ASWPCANDIDATEISISNOT', true);
            } else {
                this.props.updateBitField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.ass.ASNO, 'ASWPCANDIDATEISISNOT', false);
            }
        }
    }

    render() {
        let dropdownOptions2ndRow = [
            { id: 'Sedentary', value: 'Sedentary' },
            { id: 'Light', value: 'Light' },
            { id: 'Medium', value: 'Medium' },
            { id: 'Heavy', value: 'Heavy' },
            { id: 'Very Heavy', value: 'Very Heavy' },
        ];
        let dropdownOptions3thRow = [
            { id: 'no', value: 'no' },
            { id: 'min', value: 'min' },
            { id: 'mod', value: 'mod' },
            { id: 'max', value: 'max' },
        ];
        return (
            <PatientCareCenterNoteSection id='assessment' name='Assessment' refProp={this.props.refProp} level={5}>
                {this.props.noteType === 1 && 
                    <span className={styles.container}>
                        <div className={styles.checkbox}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.ass.ASNO}
                                field='ASWPMMI'
                                className={styles.textarea_row}
                                onClick={(res) => this.handleChange(res, 'ASWPMMITXT')}
                            />
                        </div>
                        <label className={styles.not_required}>Client is being referred for the Work Hardening/Conditioning Program to promote max level of function to assist with reaching their MMI.</label>
                    </span>

                }
                <span className={styles.container}>
                    <div className={styles.checkbox}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.ass.ASNO}
                            field='ASWPPDC'
                            className={styles.textarea_row}
                            onClick={(res) => this.handleChange(res, 'ASWPPDCTXT')}
                        />
                    </div>
                    <label className={styles.not_required}>Client is performing at a&nbsp;</label>
                    
                     <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.ass.ASNO}
                                field='ASWPPDCTXT'
                                className={styles.textarea_not_required}
                                customOptions={dropdownOptions2ndRow}
                                disabled={!this.props.isPdcSelected}
                            />
                    <label className={styles.not_required}>&nbsp; PDC level.</label>

                </span>

                {this.props.noteType === 1 && 
                <span className={styles.container}>
                    <div className={styles.checkbox}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.ass.ASNO}
                            field='ASWPDEMON'
                            className={styles.textarea_row}
                            onClick={(res) => this.handleChange(res, 'ASWPDEMONTXT')}
                        />
                    </div>
                    <label className={styles.not_required}>Client demonstrates&nbsp;</label>

                     <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.ass.ASNO}
                                field='ASWPDEMONTXT'
                                className={styles.textarea_not_required}
                                customOptions={dropdownOptions3thRow}
                                disabled={!this.props.isDemSelected}
                            />
                    <label className={styles.not_required}>&nbsp; difficulty with &nbsp; </label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.ass.ASNO}
                        field='ASWPDEMONDIFFTXT'
                        className={styles.textarea_assessment}
                        disabled={!this.props.isDemSelected}
                    />
                </span>
                }

                {this.props.noteType === 1 && 
                <span className={styles.container}>
                    <div className={styles.checkbox}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.ass.ASNO}
                            field='ASWPCANDIDATE'
                            className={styles.textarea_row}
                            onClick={(res) => this.handleChange(res, 'ASWPCANDIDATETXT')}
                        />
                    </div>
                    <label className={styles.not_required}>Client&nbsp;</label>

                    <select className={styles.diag_drop_down} value={this.props.diagVal ? this.props.diagVal : '-1'} onChange={(event) => this.handleDiagChange(event)}>
                        <option key={-1} value='-1'></option>
                        <option key={1} value='1'>is a</option>
                        <option key={2} value='2'>is not a</option>
                    </select>
                    <label className={styles.not_required}>&nbsp; candidate for the Work Hardening/Conditioning Program.</label>
                </span> 
                }
                <span className={styles.container}>
                    <DBTextArea
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.ass.ASNO}
                        field='ASFREEFORM'
                        className={this.props.noteType !== 1 && this.props.txtAreaValue === null ? styles.req_textarea : styles.simple_textarea}
                    />
                </span>
               
                <PatientCareCenterNoteAssessmentBarriers />
                {this.props.noteType === 1 &&
                    <>
                        <PatientCareCenterNoteSubjectivePDCSelector />
                    </>
                }


            </PatientCareCenterNoteSection>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));
    let ass = state.entities.notes.PTASSESSMENT[asno];

    let diagVal = state.entities.notes.PTASSESSMENT[asno].ASWPCANDIDATEISISNOT !== null ? state.entities.notes.PTASSESSMENT[asno].ASWPCANDIDATEISISNOT === true ? '1' : '2' : undefined;

    let isMmiSelected = state.entities.notes.PTASSESSMENT[asno].ASWPMMI;
    let isPdcSelected = state.entities.notes.PTASSESSMENT[asno].ASWPPDC;
    let isDemSelected = state.entities.notes.PTASSESSMENT[asno].ASWPDEMON;
    let isCadSelected = state.entities.notes.PTASSESSMENT[asno].ASWPCANDIDATE;

    let txtAreaValue = state.entities.notes.PTASSESSMENT[asno].ASFREEFORM;

    return {
        noteType,
        isMmiSelected,
        isPdcSelected,
        isDemSelected,
        isCadSelected,
        noteId,
        ass,
        txtAreaValue,
        diagVal
    };
}

const connectedPatientCareCenterNoteWpAssessment = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteWpAssessment);
export { connectedPatientCareCenterNoteWpAssessment as PatientCareCenterNoteWpAssessment };

